<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="选择地址"
    width="800px"
    class="center-dialog"
    top="0vh"

    
  >
    <el-form :inline="true"  ref="form2"  label-width="100px" :rules="rules" :model="searchFormData" class="demo-form-inline">
          <el-form-item>
            <el-input  placeholder="输入名称搜索" v-model="searchFormData.keyword" clearable=""></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addAddress">添加新地址</el-button>
          </el-form-item>
    </el-form> 
    <div class="address-cont infinite-list" v-infinite-scroll="loadMore">

       <el-form ref="form"  label-width="100px" :rules="rules" :model="formData" >
        <div 
             v-for="(item,index) in formData.addressList" 
             :key="index" class="unit"  >
             
          <el-checkbox v-model="item.checked" style="padding:10px" :checked="item.checked" :data-checked="item.checked" ></el-checkbox>
          <div style="flex:1">
            <el-form-item label="店铺名称：" >
              <el-input v-model="item.shop_name" disabled></el-input>
            </el-form-item>
           
            <el-form-item label="地址：">
              <el-input v-model="item.address" disabled></el-input>
            </el-form-item>
          
            <el-form-item label="详细地址：">
              <el-input v-model="item.adname" disabled></el-input>
            </el-form-item>
        </div>
      </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>

    <address-adds-dialog ref="addressDialog" @addAndSetAddress="addAddressCallback"></address-adds-dialog>

  </el-dialog>
</template>

<script>
import { addressList,addAddress,delAddress } from "@/api/director/address/index";

import addressAddsDialog from "@/components/address/address-adds-dialog.vue";

export default {
  components: {
    addressAddsDialog
  },
  data() {
    return {
      visible: false,
      searchFormData:{
        project_id:"",
        keyword:"",
      },
      formData:{
        addressList:[],
      },
      selectList:[],
      rules: {
       
      }
    };
  },

 
  mounted() {
    console.log("asdasdasd")
  },
  
  destroyed(){
    this.handleClose();

  },
  methods: {
    handleClose() {
      this.formData.addressList=[];
      this.visible = false;
    },

    init(datas,project_id='') {
      this.visible = true;
      this.selectList=datas;
      this.searchFormData.project_id=project_id;
      this.initData();
      
    },

    initData(){
      var that=this;
      this.formData.addressList=[];
      addressList(this.searchFormData).then((response) => {
              console.log(response);
              if(response.code==200){
                that.formData.addressList=response.data;
                for (let item of that.formData.addressList) {
                  that.$set(item,'checked',that.setChecked(item));
                }
              }else{
                this.$message({
                  message: response.msg?response.msg:"获取地址信息失败",
                });
              }
            });
    },

    setChecked(item){
      var checked=false;
      for (let item2 of this.selectList) {
        if(item.u_address_id ==item2.u_address_id){
          checked=true;
        }
      }
      return checked;
    },


    addAddress(){
      this.$refs.addressDialog.init();
    },

    addAddressCallback(){
      this.initData();
    },

    search(){
      this.initData();
    },
  
    
    submit(){
      var that=this;
      var selectedList=[];

      this.$refs["form"].validate((valid) => {
        if (valid) {

          for (let item of that.formData.addressList) {
              if(item.checked==true){
                selectedList.push(
                  item
                );
              }
            }
            that.$emit("setAddress",selectedList);
            this.visible = false;
        }

      });

    },

    loadMore(){

    }
    
  },

 
};
</script>

<style lang="scss" scoped>



  .center-dialog {
    height: calc(100vh - 40px);;
    //overflow: hidden;
   // overflow-y: auto;
   padding: 0px 25px;
  }

  .address-cont{
    height: calc(75vh - 50px);
    height: -webkit-calc(75vh - 50px);
    height: -moz-calc(75vh - 50px);
    overflow:auto
  }

  .unit{
    border: 1px solid #c1c1c1;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .title{
      color: #666666;
      width:100px;
      text-align: right;
      line-height: 20px;
    }
  }
  
</style>
